import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="light" className="titleBlock-align-left" mdxType="TitleBlock" />
    <h2 {...{
      "id": "why-pdf-embed-api"
    }}>{`Why PDF Embed API?`}</h2>
    <TextBlock slots="image, heading, text" width="33%" theme="light" className="align-left icon-xl-size horizontal-align-heading" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/0784d9ed7d80f7a24dd05df0a6264d48/accurate_rendering.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "accurate-consistent-pdf-rendering"
    }}>{`Accurate, consistent PDF rendering`}</h3>
    <p>{`Whether on dynamic or static pages, deliver the highest quality PDF rendering available.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="light" className="align-left icon-xl-size horizontal-align-heading" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/4df833320f3bc6d456351a3b3da97373/customizable_experience.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "customizable-user-experience"
    }}>{`Customizable user experience`}</h3>
    <p>{`Choose exactly how to display a PDF and use the callbacks and annotations APIs to provide programmatic control and enable digital collaboration.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="light" className="align-left icon-xl-size horizontal-align-heading" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/f85cedbb73ff4b1ccf002e6dcaadeb26/analytics.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "analytics-on-pdf-usage"
    }}>{`Analytics on PDF usage`}</h3>
    <p>{`Use analytics to understand how users interact with PDFs, including time spent on a page and searches.`}</p>
    <TextBlock slots="buttons" isCentered theme="light" className="margin-top-zero" mdxType="TextBlock" />
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/dc-integration-creation-app-cdn/main.html?api=pdf-embed-api"
        }}>{`Get free credentials`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      